/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { journeysHorizontalNavEntryPoint } from '@jira/navigation-apps__horizontal-nav-jsm-journeys/JourneysHorizontalNav.entrypoint.tsx';
import { pendingJourneysEntryPoint } from '@jira/spa-apps__servicedesk-pending-journeys/src/pendingJourneysEntryPoint.entrypoint.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { pendingJourneysRoute } from '@jira/router-routes__journeys-routes/src/pendingJourneysRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { APP_NAMES, toPackageName } from '@jira/servicedesk__common/src/toPackageName.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';

const pendingJourneysPageEntryPointWithNav = createPageEntryPoint({
	main: pendingJourneysEntryPoint,
	horizontalNavigation: journeysHorizontalNavEntryPoint,
});

const pendingJourneysPageEntryPointWithoutNav = createPageEntryPoint({
	main: pendingJourneysEntryPoint,
});

export const pendingJourneysRouteEntry: Route = createEntry(pendingJourneysRoute, () => ({
	group: 'servicedesk',
	ufoName: 'jsm.journeys',
	// eslint-disable-next-line no-restricted-syntax
	component: () => null,

	navigation: {
		menuId: MenuIdProjects,
	},

	layout: serviceProjectLayout,

	resources: [
		...getServiceDeskNavigationResources(),
		...getServicedeskPageContextResources(),
		getConsolidationStateResource(),
	],

	entryPoint: () =>
		fg('jsm-active-journeys-table-m0')
			? pendingJourneysPageEntryPointWithNav
			: pendingJourneysPageEntryPointWithoutNav,

	meta: {
		reporting: {
			id: 'journeys',
			packageName: toPackageName(APP_NAMES.JOURNEYS),
			teamName: 'JSM Grape Soju',
		},
	},

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
